"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toggleListType_1 = require("../utils/toggleListType");
/**
 * Toggle numbering at selection
 * If selection contains numbering in deep level, toggle numbering will decrease the numbering level by one
 * If selection contains bullet list, toggle numbering will convert the bullet list into number list
 * If selection contains both bullet/numbering and normal text, the behavior is decided by corresponding
 * realization of browser execCommand API
 * @param editor The editor instance
 * @param startNumber (Optional) Start number of the list
 */
function toggleNumbering(editor, startNumber) {
    toggleListType_1.default(editor, 1 /* Ordered */, startNumber);
}
exports.default = toggleNumbering;
//# sourceMappingURL=toggleNumbering.js.map